export default (url: string) => {
    const match = url.match(/\(.+\)/);
    if (match && match[0]) {
        return match[0].substr(1, match[0].length - 2);
    }
    return 0;
};
